import EmptyFolderIcon from './EmptyFolderIcon'

export default EmptyFolderIcon
